






































































































































































































































import ModalMixin from '@/mixins/modal.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { Component, Mixins } from 'vue-property-decorator';
import { IPaymentGatewayInstallment } from '@resclick/data-access';
import { PAYMENT_GATEWAYS } from '@resclick/data-access';

@Component
export default class PaymentGatewaysInstallmentModal extends Mixins(ModalMixin) {
  form!: CrsForm<'paymentGateways', 'update'>;
  unique = false;

  // GROUPED INSTALLMENTS
  get multiInstallments() {
    if (!this.form.fields.multiInstallments) this.form.fields.multiInstallments = [];
    return this.form.fields.multiInstallments;
  }

  currentBank = '';

  getGateway(key: string) {
    return (PAYMENT_GATEWAYS as any)[key].prettyName;
  }

  addBank() {
    if (this.currentBank === '') return;

    this.multiInstallments.push({
      template: this.currentBank,
      installments: [],
    });

    this.currentBank = '';
  }

  get bankOptions() {
    const banksKeys = Object.keys(PAYMENT_GATEWAYS).filter((key) => !['IYZICO', 'FASTPAY'].includes(key));
    return banksKeys.map((key: string) => {
      const label = (PAYMENT_GATEWAYS as any)[key].prettyName;
      return {
        label,
        value: key,
      };
    });
  }

  addInstallmentToBank(bank: any) {
    if (!bank.installments) bank.installments = [];
    const lastInstallment = bank.installments[bank.installments.length - 1] || {
      numOfInstallment: 0,
      days: 1,
      purchasePercent: 0,
      salePercent: 0,
      plusInstallment: 0,
    };

    bank.installments.push({
      numOfInstallment: lastInstallment.numOfInstallment + 1,
      days: 1,
      purchasePercent: 0,
      salePercent: 0,
      plusInstallment: 0,
    });
  }

  removeInstallmentFromBank(bank: any, index: number) {
    bank.installments.splice(index, 1);
  }

  removeBank(index: number) {
    this.multiInstallments.splice(index, 1);
  }

  // SINGLE GATEWAY INSTALLMENTS

  get installments() {
    if (!this.form.fields.installments) this.form.fields.installments = [];
    return this.form.fields.installments;
  }

  submit() {
    if (this.form.fields.installments && this.form.fields.installments.length) {
      if (!this.duplicatedFields().length) {
        this.sort();
        this.onSubmit({ paymentGatewayId: this.id });
      }
    } else if (this.form.fields.multiInstallments && this.form.fields.multiInstallments.length) {
      this.onSubmit({ paymentGatewayId: this.id });
    }
  }

  duplicatedFields(): number[] {
    const installments =
      this.form.fields.installments?.map((item: IPaymentGatewayInstallment) => item.numOfInstallment) || [];
    return installments.reduce((acc: number[], el: number, i, arr) => {
      if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el);
      return acc;
    }, []);
  }

  /*
  isDuplicated(): boolean {
    const installments =
      this.form.fields.installments?.map((item: IPaymentGatewayInstallment) => item.numOfInstallment) || [];
    return installments.some((item: number, value: number) => {
      return installments.indexOf(item) != value;
    });
  }
  */

  sort() {
    this.form.fields.installments?.sort(
      (el: IPaymentGatewayInstallment, other: IPaymentGatewayInstallment) =>
        el.numOfInstallment - other.numOfInstallment,
    );
  }

  findBiggest(): number {
    return Math.max(...this.installments.map((el: IPaymentGatewayInstallment) => el.numOfInstallment));
  }

  addInstallment() {
    let biggestValue = this.findBiggest();
    this.installments.push({
      numOfInstallment: biggestValue + 1 <= 0 ? 1 : biggestValue + 1,
      days: 1,
      purchasePercent: 0,
      salePercent: 0,
    });
  }

  removeInstallment(index: number) {
    if (Array.isArray(this.installments) && this.installments.length === 1) {
      return;
    }

    if (Array.isArray(this.installments)) {
      this.installments.splice(index, 1);
    }
  }

  created() {
    this.form = this.$crsForm('paymentGateways', 'update', {
      installments: this.installments,
    });
  }

  async getForm() {
    return compass.do('paymentGateways', 'findOne', {
      params: { paymentGatewayId: this.id },
      select: ['installments', 'multiInstallments', 'template'],
    });
  }
}
